import React, {useState} from 'react';
import { useSession } from '../../../../Components/Session';
import Modal from '../../../../Components/Modal';
import Form, { Actions, Address, PhoneNumber, PhoneNumberValidator, RequiredValidator, TextField } from '../../../../Components/Form';
import { Roles, useUser } from '../../../../Data/Users';
import { useBusiness } from '../../../../Data/Business';
import PendingVoucher from '../../../Billing/PendingVoucher';
import NextSteps from './NextSteps';
import { useOnboardingJourney } from '../../../../Data/Onboarding';
import Recommend from './Recommend';

const Onboarding = () => {
    const theJourney = useOnboardingJourney(true);
    const {user, business, refresh, isRoleSufficient} = useSession();
    const [isShowingNextSteps, setIsShowingNextSteps] = useState(false);

    if (user && !user.firstName) {
        return <UserNameRequired refresh={refresh} />
    }

    if (business && !business?.address?.postcode) {
        return <BusinessAddressRequiredRequired refresh={refresh} />
    }

    return <>
        {isRoleSufficient(Roles.Owner) && <PendingVoucher onComplete={refresh} />}
        <NextSteps isShowing={isShowingNextSteps} setIsShowing={setIsShowingNextSteps} theJourney={theJourney} />

        {!isShowingNextSteps && <Recommend theJourney={theJourney} />}
    </>
}

const UserNameRequired = (refresh) => {
    const {user, update} = useUser();

    return <Modal title="Welcome to getSoapy" isOpen={true} setIsOpen={() => null}>
        <Form data={user} onSubmit={update} afterSubmit={refresh} closeModalOnSubmit waitForData>
            <p className="text-muted">
                We're glad you're here! To get started, please tell us your name?
            </p>
            <TextField name="firstName" label="First name" validators={[RequiredValidator]} />
            <TextField name="lastName" label="Surname" validators={[RequiredValidator]} />
            <Actions submit={{label: 'Save'}} />
        </Form>
    </Modal>
}

const BusinessAddressRequiredRequired = (refresh) => {
    const {business, saveDetails} = useBusiness();

    return <Modal title="Business details" isOpen={true} setIsOpen={() => null}>
        <Form data={business} onSubmit={saveDetails} afterSubmit={refresh} closeModalOnSubmit waitForData>
            <p className="text-muted">
                To enable some features including nearby leads and route optimisations, we need to know where you're based.
            </p>
            <TextField name="name" label="Business Name" validators={[RequiredValidator]} />
            <Address name="address" label="Address" validators={[RequiredValidator]} />
            <PhoneNumber name="phoneNumber" label="Phone number" validators={[RequiredValidator, PhoneNumberValidator]} />
            <Actions submit={{label: 'Save'}} />
        </Form>
    </Modal>
}



export default Onboarding;
